import { OrganizationCRMMetadataSchema, OrganizationLocalizationIntegrationSchema } from "@superwall-me/schema";
export const parseOrganization = (organization)=>{
    const crmMetadata = organization.crmMetadata ? OrganizationCRMMetadataSchema.parse(organization.crmMetadata) : {};
    const localizationIntegration = organization.localizationIntegration ? OrganizationLocalizationIntegrationSchema.parse(organization.localizationIntegration) : undefined;
    return {
        ...organization,
        crmMetadata,
        localizationIntegration
    };
};
